import React from 'react';

import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

export const ErrorComponent: React.FC = () => {
  const { t } = useTranslation('errors');
  const { message } = t('componentError');
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100%"
    >
      <Box maxWidth={500}>
        <TextV2>{message()}</TextV2>
      </Box>
    </Flex>
  );
};
